import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=80253258&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"
import style0 from "./user-list.vue?vue&type=style&index=0&id=80253258&prod&scoped=true&lang=scss"
import style1 from "./user-list.vue?vue&type=style&index=1&id=80253258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80253258",
  null
  
)

export default component.exports